import FroalaEditorView from 'react-froala-wysiwyg/FroalaEditorView'
import { history } from 'store/store'
import { ResponsePreview, ShortcutBadge } from '../styles'
import { copyTextHandler, generateSlug, getTitle, handleApiError, logAmplitudeEvent } from 'utils/helpers'
import { getContentByUUID_api, updateCopyCount_api } from 'store/apis'
import UpgradeButton from 'modules/app/components/UpgradeButton'
import { ActionDropdown } from 'modules/app/styles'
import { Button, DropdownToggle, UncontrolledTooltip } from 'reactstrap'
import { connect } from 'react-redux'
import { pinToCategory_action, setCurrentResponseDropdown, setDropdownDirection, setIsCopyingLoading, setResponseDropdoenStatus, setResponseDropdownPosition, toggleCategoryModal_action, toggleDeleteCategoryModal_action, toggleDeleteContentModal_action, toggleMoveToCategoryModal_action } from 'store/actions'
import { ReactComponent as PushPinIcon } from 'assets/images/icons/push_pin.svg'
import { ButtonLoader } from 'utils/storageUtils'
import { direction } from 'direction'

const ResponseCard = (props) => {
  const { response, setDropdownDirection, setIsCopyingLoading, isCopyingLoading, setResponseDropdoenStatus, setResponseDropdownPosition, setCurrentResponseDropdown, showResponseDropdown, currentResponseDropdown } = props

  const triggerCopyTextHandler = async (e, type) => {
    try {
      e.stopPropagation()
      const ActionButtons = e.target.closest('.action-buttons')
      ActionButtons.classList.add('show')
      if (response.content) {
        await copyTextHandler(type, response)
      } else {
        setIsCopyingLoading(true)
        const data = await getContentByUUID_api(response.uuid)
        if (data && data.id) {
          await copyTextHandler(type, data)
        }
        setIsCopyingLoading(false)
      }
      setResponseDropdoenStatus(false)

      const ALL_ACTION_BUTTONS = document.getElementsByClassName('action-buttons')
      for (let i = 0; i < ALL_ACTION_BUTTONS.length; i++) {
        ALL_ACTION_BUTTONS[i].classList?.remove('show')
      }
      const ALL_COPYBUTTONS = [...document.getElementsByClassName('copyButton'), ...document.getElementsByClassName('dropdown-toggle')]
      for (let i = 0; i < ALL_COPYBUTTONS.length; i++) {
        ALL_COPYBUTTONS[i].classList?.remove('green')
        ALL_COPYBUTTONS[i].classList?.add('black')
        ALL_COPYBUTTONS[i].querySelector('span').textContent = 'COPY'
      }
      ActionButtons.classList.add('show')
      const BUTTONS = [ActionButtons.querySelector('.copyButton'), ActionButtons.querySelector('.dropdown-toggle')]
      if (BUTTONS.length > 0) {
        setTimeout(() => {
          BUTTONS[0].querySelector('span').textContent = 'COPIED'
          BUTTONS.forEach((button) => {
            button.classList.remove('black')
            button.classList.add('green')
          })
        }, 100)
        setTimeout(() => {
          BUTTONS[0].querySelector('span').textContent = 'COPY'
          BUTTONS.forEach((button) => {
            button.classList.remove('green')
            button.classList.add('black')
          })
          ActionButtons.classList.remove('show')
        }, 1800)
      }

      // Update view/use count
      updateCopyCount_api(response.id)
    } catch (error) {
      handleApiError(error)
    }
  }

  const sortableHandle = require('react-sortable-hoc').sortableHandle
  const DragHandle = sortableHandle(() => {
    return <span className='dragIcon'>: :</span>
  })
  return (
    <div className='response-preview'>
      <div className={'sortHandleBox'}>
        <DragHandle />
      </div>
      <ResponsePreview className={`mx-2 ${!response.is_accessible ? 'disabled' : ''}`}>
        <p className='heading' dir={direction(response.title)}>
          <a
            dir={direction(response.title)}
            href={`/response/${generateSlug(response)}`}
            onClick={(e) => {
              e.preventDefault()
              if (response.is_accessible) {
                history.push(`/response/${generateSlug(response)}`)
              }
            }}>
            {response.pinned_to_category && (
              <>
                <PushPinIcon id={`response${response.id}`} style={{ height: '20px', width: '20px', marginRight: '0.3rem' }} />
                <UncontrolledTooltip target={`response${response.id}`}>Pinned to category</UncontrolledTooltip>
              </>
            )}
            {getTitle(response.title)}
          </a>
          {response.shortcut && <ShortcutBadge dir={direction(response.shortcut)}>{response.shortcut}</ShortcutBadge>}
        </p>
        <div className={`text ${response.plain_content_short.length > 100 && 'ellipsis'}`} dir='auto'>
          <FroalaEditorView model={response.plain_content_short} />
        </div>
        {!response.is_accessible && <UpgradeButton />}
      </ResponsePreview>
      <ActionDropdown className={`action-buttons ${!response.is_accessible ? 'disabled' : ''} ${showResponseDropdown && currentResponseDropdown?.id === response?.id ? 'arrow' : ''}`} direction='right' isOpen={showResponseDropdown && currentResponseDropdown?.id === response?.id} toggle={(event) => {
        const sideMenu = document.querySelector('#responseScrollDiv')?.getBoundingClientRect();

        if (event.target.className !== 'dropdownChild') {
          setResponseDropdoenStatus(!showResponseDropdown);
          const buttonRect = event.target.getBoundingClientRect();

          const left = buttonRect.left + buttonRect.width - sideMenu?.left;
          const top = buttonRect.top + window.scrollY - sideMenu?.top;

          if (sideMenu.bottom - buttonRect.bottom < 50) {
            setResponseDropdownPosition({ left, top: top - 50 });
            setDropdownDirection('up');
          } else {
            setResponseDropdownPosition({ left, top });
            setDropdownDirection('down');
          }

          setResponseDropdoenStatus(!showResponseDropdown);
          setCurrentResponseDropdown(response);

          document.body.style.overflow = 'hidden';
        }
      }}>
        {response.is_accessible && (
          <Button
            tabIndex={'0'}
            type='button'
            className='black rounded-border pl-2 copyButton shadow-none'
            onClick={async (e) => {
              logAmplitudeEvent('Web: Copied a response to clipboard')
              triggerCopyTextHandler(e, 'html')
            }}>
            {isCopyingLoading && <ButtonLoader />}
            {!isCopyingLoading && <span>COPY</span>}
          </Button>
        )}
        <DropdownToggle split id={`responseDropdownButton-${response?.id}`} className='black rounded-border shadow-none' />

      </ActionDropdown>
    </div>
  )
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  isFree: state.company.company.isFree,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  is_subscribed: state.subscription.is_subscribed,
  showResponseDropdown: state.app.isResponseDropdownVisible,
  isCopyingLoading: state.app.isCopyingLoading,
  currentResponseDropdown: state.app.currentResponseDropdown
})

const mapDispatchToProps = (dispatch) => ({
  pinToCategory: (content) => dispatch(pinToCategory_action(content)),
  toggleCategoryModal: (status, item) => dispatch(toggleCategoryModal_action(status, item)),
  toggleDeleteContentModal: (status, item, redirectToHome) => dispatch(toggleDeleteContentModal_action(status, item, redirectToHome)),
  toggleDeleteCategoryModal: (status, item, redirectToHome) => dispatch(toggleDeleteCategoryModal_action(status, item, redirectToHome)),
  toggleMoveToCategoryModal: (showMoveToCategoryModal, item) => dispatch(toggleMoveToCategoryModal_action(showMoveToCategoryModal, item)),
  setResponseDropdoenStatus: (status) => dispatch(setResponseDropdoenStatus(status)),
  setResponseDropdownPosition: (position) => dispatch(setResponseDropdownPosition(position)),
  setCurrentResponseDropdown: (response) => dispatch(setCurrentResponseDropdown(response)),
  setIsCopyingLoading: (status) => dispatch(setIsCopyingLoading(status)),
  setDropdownDirection: (status) => dispatch(setDropdownDirection(status)),
})
export default connect(mapStateToProps, mapDispatchToProps)(ResponseCard)
